export default __webpack_public_path__ + "1b9d27bb139cc9a9b3df17eeb7bef1c9.svg";